import React from 'react';
import NeuroRoomJPG from '@assets/images/neuro-room.jpg';
import NeuroRoomMobileJPG from '@assets/images/neuro-room-mobile.jpg';
// eslint-disable-next-line import/no-cycle
import Contact from '~/components/atoms/Contact/Contact';
import HeaderFooterLayout from '~/components/molecules/HeaderFooterLayout/HeaderFooterLayout';

const ContactPage: React.FC = () => {
  return (
    <>
      <HeaderFooterLayout
        desktopHero={NeuroRoomJPG}
        mobileHero={NeuroRoomMobileJPG}
        altHero="Neurologie Praxisraum"
        enLink="/en/contact/"
        deLink="/kontakt/"
      >
        <Contact />
      </HeaderFooterLayout>
    </>
  );
};

export default ContactPage;
